import { render } from "./RLTS.vue?vue&type=template&id=0b81f8b1"
import script from "./RLTS.vue?vue&type=script&lang=js"
export * from "./RLTS.vue?vue&type=script&lang=js"

import "./RLTS.vue?vue&type=style&index=0&id=0b81f8b1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__